import { render } from "./uiCollapsibleBox.vue?vue&type=template&id=01773c10"
import script from "./uiCollapsibleBox.vue?vue&type=script&lang=js"
export * from "./uiCollapsibleBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__